import { Store } from '@tanstack/react-store'

const DEFAULT_DATE_RANGE = 'week'

export const defaultUserCardState = {
  incomingTransfers: {
    loading: false,
    list: [],
    fromDate: '',
    toDate: '',
    limit: 20,
    dateRange: DEFAULT_DATE_RANGE,
  },
}

export const userCardStore = new Store(defaultUserCardState)

export const resetUserCard = () => {
  userCardStore.setState(defaultUserCardState)
}
